import styled from 'styled-components';

export const Block = styled.div`
  padding: 12px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#fde68a')};
  background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(245, 158, 11, 0.08)' : '#fffbeb')};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Title = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#fbbf24' : '#92400e')};
`;

export const Description = styled.p`
  margin: 2px 0 0;
  font-size: 12px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#78350f')};
`;

export const Note = styled.p`
  margin: 8px 0 0;
  font-size: 12px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
`;

export const RefundButton = styled.button<{ $variant?: 'solid' | 'ghost' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 16px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;

  ${({ $variant = 'solid', theme }) => ($variant === 'ghost'
    ? `
      border: 1px solid ${theme.mode === 'dark' ? '#374151' : '#dcdfe4'};
      background: transparent;
      color: ${theme.mode === 'dark' ? '#e5e7eb' : '#374151'};

      &:hover:not(:disabled) {
        background: ${theme.mode === 'dark' ? 'rgba(255,255,255,0.06)' : '#f3f4f6'};
      }
    `
    : `
      border: 1px solid #111827;
      background: #111827;
      color: #ffffff;

      &:hover:not(:disabled) {
        background: #1f2937;
      }
    `)}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const AmountField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
`;

export const AmountLabel = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#374151')};
`;

export const AmountRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AmountInput = styled.input`
  flex: 1;
  height: 38px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 14px;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1f2937' : '#ffffff')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#1f2937')};

  &:focus {
    outline: none;
    border-color: #111827;
  }
`;

export const AmountSuffix = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
`;

/**
 * Wyjście do ustawień płatności z okna zwrotu. Przycisk, nie link, bo panel nawiguje
 * routerem (adres niesie prefiks języka), a nie przeładowaniem strony.
 */
export const SettingsLink = styled.button`
  align-self: flex-start;
  padding: 0;
  border: none;
  background: none;
  font-size: 13px;
  font-weight: 600;
  color: #635bff;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;

  &:hover { opacity: 0.85; }
`;

export const NoteInput = styled.textarea`
  width: 100%;
  min-height: 64px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  resize: vertical;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1f2937' : '#ffffff')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#1f2937')};

  &:focus {
    outline: none;
    border-color: #111827;
  }
`;

export const SuggestionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;

/**
 * Podpowiedź kwoty. `$active` = ta, którą hotel właśnie wybrał.
 *
 * Bez zaznaczenia obie wyglądały tak samo po kliknięciu i jedyną informacją o wyborze
 * była liczba w polu obok. Przy dwóch kwotach różniących się o opłatę Stripe łatwo było
 * stracić rachubę, którą się kliknęło.
 */
export const SuggestionButton = styled.button<{ $active?: boolean }>`
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  cursor: pointer;
  border: 1px solid ${({ $active, theme }) => {
    if ($active) return '#111827';
    return theme.mode === 'dark' ? '#374151' : '#e5e7eb';
  }};
  background: ${({ $active, theme }) => {
    if ($active) return theme.mode === 'dark' ? '#111827' : '#111827';
    return theme.mode === 'dark' ? '#1f2937' : '#ffffff';
  }};
  color: ${({ $active, theme }) => {
    if ($active) return '#ffffff';
    return theme.mode === 'dark' ? '#e5e7eb' : '#374151';
  }};

  &:hover {
    border-color: #111827;
  }
`;

/** Miejsce kwoty na czas jej liczenia — okno ma wysokość, zanim poznamy liczby. */
export const LoadingBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 96px;
  font-size: 13px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
`;
